module.exports = __webpack_public_path__ + "img/ckgd.fefdd4c4.png";